const user = {
  state: {
    newShow: true,
    userInfo: {},
    commonInfo: {}, // 快递常用联系人信息
  },
  mutations: {
    setUserInfo(state, data) {
      state.userInfo = data
    },
    setCommonInfo(state, data) {
      state.commonInfo = data
    }
  },
  actions: {}
}

export default user



// WEBPACK FOOTER //
// ./src/store/modules/user.js